<template>
    <v-chip :color="color"
        @click="$emit('change', !value)"
        :class=" `elevation-0`+ ` ` + className "
        :disabled="disabled">
        <span :class="className">{{ label }}</span>
    </v-chip>
</template>

<script>
    export default {
        name:"FormSelector",
        components: {
            
        },
        model: {
            prop: "value",
            event: "change",
        },
        props: {
            label: {
                type: String,
                default: ""
            },
            value: {
                type: [ Boolean, Number ],
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            },
        },
        computed: {
            color() {
                return this.value ? "green" : "gray";
            },
            className() {
                return this.value ? "form-selector-selected" : "";
            }
          
        },
        methods:{
        }
    }
</script>

<style lang="scss" scoped>
    #app {
        .form-selector-selected {
            font-weight: bold;
            opacity: 1;
            
        }
  
    }
</style>